/**
 * WO-D2.M — account hub.
 *
 * WO-M0 — rebuilt on the design system: Screen / Card / ListRow / Badge / Text.
 */
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { useQuery } from '@tanstack/react-query';
import { getLicense } from '../../../../src/api/account';
import { Screen, Text, Card, ListRow, Badge, licenseBadge } from '../../../../src/components/ui';
import { theme } from '../../../../src/theme';

export default function AccountHome() {
  const router = useRouter();
  const license = useQuery({ queryKey: ['license'], queryFn: getLicense });

  const licBadge = license.data ? licenseBadge(license.data.status ?? 'trial') : null;

  return (
    <Screen scroll>
      <Text variant="title">Account</Text>

      <Card>
        <Text variant="label" color="secondary">Plan</Text>
        {license.isLoading ? (
          <ActivityIndicator accessibilityLabel="Loading plan" />
        ) : (
          <View style={styles.planRow}>
            <Text variant="bodyStrong">
              {license.data?.has_license
                ? `${license.data.plan ?? 'Subscription'}`
                : 'Trial'}
              {license.data?.seats ? ` · ${license.data.seats} seats` : ''}
            </Text>
            {licBadge ? <Badge status={licBadge.key} label={licBadge.label} /> : null}
          </View>
        )}
      </Card>

      <View style={styles.list}>
        <ListRow
          title="Your trades"
          subtitle="Pick the trades you work in; shapes your service suggestions"
          onPress={() => router.push('/(app)/account/trades')}
        />
        <ListRow
          title="Users & roles"
          subtitle="Manage team members and permissions"
          onPress={() => router.push('/(app)/account/users')}
        />
        <ListRow
          title="Team directory"
          subtitle="Everyone in your organization"
          onPress={() => router.push('/(app)/account/team')}
        />
        <ListRow
          title="Text & email senders"
          subtitle="Configure messaging and inbound address"
          onPress={() => router.push('/(app)/account/comms')}
        />
        <ListRow
          title="Billing & plan"
          subtitle="Manage subscription and payment"
          onPress={() => router.push('/(app)/account/billing')}
        />
        <ListRow
          title="Payments"
          subtitle="Connect Stripe and set up your pay-by-invoice page"
          onPress={() => router.push('/(app)/account/payments')}
        />
        <ListRow
          title="Branding"
          subtitle="Invoice template, accent color, logo, and footer note"
          onPress={() => router.push('/(app)/account/branding')}
        />
        <ListRow
          title="Sessions & security"
          subtitle="Active devices; sign out everywhere"
          onPress={() => router.push('/(app)/account/security')}
        />
        <ListRow
          title="Delete account"
          subtitle="Permanently remove your organization and all data"
          onPress={() => router.push('/(app)/account/delete-account')}
        />
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  planRow: { flexDirection: 'row', alignItems: 'center', gap: theme.spacing.md },
  list: { gap: theme.spacing.sm },
});
